import styled from 'styled-components';
import { motion } from 'framer-motion';

export const DropdownContainer = styled(motion.div)`
  position: absolute;
  top: 100%;
  right: 0;
  width: 320px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  padding: 24px;
  z-index: 1000;
  margin-top: 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray100};

  @media (max-width: 768px) {
    width: calc(100vw - 32px);
    position: fixed;
    right: 16px;
    top: 64px;
    padding: 20px;
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
`;

export const LargeAvatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid ${({ theme }) => theme.colors.gray100};
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProfileName = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
  margin: 0;
`;

export const ProfileEmail = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.gray700};
  
  svg {
    color: ${({ theme }) => theme.colors.gray500};
  }
`;

export const ProfileRole = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.gray700};
  font-weight: 500;

  svg {
    color: ${({ theme }) => theme.colors.gray500};
  }
`;

export const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const MenuIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.gray100};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.gray900};
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const MenuTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
  font-size: 0.95rem;
`;

export const MenuSubtitle = styled.div`
  color: ${({ theme }) => theme.colors.gray500};
  font-size: 0.85rem;
`;

export const LogoutButton = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #F97316;
  background: white;
  color: #F97316;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1rem;

  &:hover {
    background-color: #FFF7ED;
  }
`;
